module.exports = __webpack_public_path__ + "static/img/header_bg2.c348a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/servitor/circus/header/header_bg2.png
// module id = A7SV
// module chunks = 7